import React, { useCallback, useEffect, useState } from 'react'
import GalleryPlansTable from './GalleryPlansTable/GalleryPlansTable';
import { getGalleryPlanAPI } from '../../utils/APIs/galleryPlansApis';
import { getPhotographyPlansAPI } from '../../utils/APIs/photographyPlansApis';
import { getEditingPlansAPI } from '../../utils/APIs/editingPlansApis';
import "./GalleryPlans.css"
import AddGalleryPlanModal from './AddGalleryPlanModal/AddGalleryPlanModal';
const GalleryPlans = () => {
    const [imagePlans, setImagePlans] = useState([]);

    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const LIMIT = 10;
    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        const stored = sessionStorage.getItem("isSidebarOpen");
        return stored !== null ? JSON.parse(stored) : true;
    });
    const [showAddModal, setShowAddModal] = useState(false);
    const [activeTab, setActiveTab] = useState("gallery");
    const [subTab, setSubTab] = useState("standard");

    useEffect(() => {
        const interval = setInterval(() => {
            const stored = sessionStorage.getItem("isSidebarOpen");
            const parsed = stored !== null ? JSON.parse(stored) : true;

            if (parsed !== isSidebarOpen) {
                setIsSidebarOpen(parsed);
            }
        }, 10);

        return () => clearInterval(interval);
    }, [isSidebarOpen]);

    const fetchData = useCallback(async (pageNumber = page) => {
        try {
            let res;
            if (activeTab === "gallery") {
                res = await getGalleryPlanAPI(pageNumber, LIMIT);
            } else if (activeTab === "hourly") {
                res = await getPhotographyPlansAPI(pageNumber, LIMIT, subTab);
            } else if (activeTab === "editing") {
                res = await getEditingPlansAPI(pageNumber, LIMIT);
            }
            const data = res?.data?.data || res?.data?.editingPlans || res?.data?.plans || [];
            setImagePlans(data);
            setTotal(res?.data?.meta?.total || res?.data?.total || data.length || 0);
        } catch (err) {
            console.error("Plans fetch failed", err);
            setImagePlans([]);
            setTotal(0);
        }
    }, [activeTab, subTab, page]);

    useEffect(() => {
        setPage(1); // Reset to page 1 when switching tabs
    }, [activeTab, subTab]);

    useEffect(() => {
        fetchData(page);
    }, [fetchData, page]);

    const totalPages = Math.ceil(total / LIMIT);
    const getPageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        return pages;
    };

    return (
        <>
        <div
            className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
            style={{ marginTop: "100px" }}
        >
            <div className="my-quote-page page-inner-wrapper">
                <h2 className="page-title">Gallery Plan </h2>

                {/* Tabs */}
                <div className="custom-tabs">
                    <div
                        className={`tab-item ${activeTab === "gallery" ? "active" : ""}`}
                        onClick={() => setActiveTab("gallery")}
                    >
                        Gallery Plan
                    </div>
                    <div
                        className={`tab-item ${activeTab === "hourly" ? "active" : ""}`}
                        onClick={() => setActiveTab("hourly")}
                    >
                        Hourly Plan
                    </div>
                    <div
                        className={`tab-item ${activeTab === "editing" ? "active" : ""}`}
                        onClick={() => setActiveTab("editing")}
                    >
                        Editing Plan
                    </div>
                </div>

                {/* Sub-Tabs for Hourly */}
                {(activeTab === "hourly") && (
                    <div className="sub-tabs-container">
                        <div
                            className={`sub-tab ${subTab === "standard" ? "active" : ""}`}
                            onClick={() => setSubTab("standard")}
                        >
                            Standard
                        </div>
                        <div
                            className={`sub-tab ${subTab === "premium" ? "active" : ""}`}
                            onClick={() => setSubTab("premium")}
                        >
                            Premium
                        </div>
                    </div>
                )}


                <div className="role-header">
                    <button
                        className="btn-add-role"
                        onClick={() => setShowAddModal(true)}
                    >
                        + Add {activeTab === "gallery" ? "Gallery" : activeTab === "hourly" ? "Hourly" : "Editing"} Plan
                    </button>
                </div>

                <GalleryPlansTable
                    data={imagePlans}
                    page={page}
                    limit={LIMIT}
                    refreshData={() => fetchData(page)}
                    activeTab={activeTab}
                    subTab={subTab}
                />

                {totalPages > 1 && (
                    <div className="pagination">
                        {/* Prev */}
                        <button
                            className="pagination-btn"
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                        >
                            Prev
                        </button>

                        {/* Page Numbers */}
                        {getPageNumbers().map((p) => (
                            <button
                                key={p}
                                className={`pagination-btn ${p === page ? "active" : ""}`}
                                onClick={() => setPage(p)}
                            >
                                {p}
                            </button>
                        ))}

                        {/* Next */}
                        <button
                            className="pagination-btn"
                            disabled={page === totalPages}
                            onClick={() => setPage(page + 1)}
                        >
                            Next
                        </button>
                    </div>
                )}



            </div>
            <AddGalleryPlanModal
                show={showAddModal}
                onClose={() => setShowAddModal(false)}
                refreshData={() => fetchData(page)}
                activeTab={activeTab}
                subTab={subTab}
            />
        </div>
        </>
    )
}

export default GalleryPlans